import * as React from 'react'
import TextField from '../TextField'
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete'
import { Typography } from '@mui/material'
import ListItemText from '@mui/material/ListItemText'
import './index.css'

const PlaceAutoComplete = ({
  handleValue,
  defaultValue,
  name,
  label,
  cityOnly,
  required,
  zIndex,
  borderLess,
  bgwhite,
}) => {
  const googleAPI = new global.google.maps.places.AutocompleteService()
  const [placeDetails, updatePlaceDetails] = React.useState([])
  const filter = createFilterOptions();
  const fetchPlaces = val => {
    googleAPI.getPlacePredictions({ input: val }, data => {
      data && updatePlaceDetails(data)
    })
  }
  return (
    <Autocomplete
      fullWidth
      sx={{ color: '#66668f' }}
      ListboxProps={{
        sx: {
          padding: '8px',
          boxshadow: '0px 2px 10px rgba(0, 0, 0, 0.1)',
          borderRadius: '5px',
          // marginTop: '10px'
        },
      }}
      size="small"
      value={defaultValue}
      onChange={(event, newValue) => {
        if (newValue && newValue.inputValue) {
          // Create a new value from the user input
          handleValue({ name: name, value: newValue.inputValue })
        } else {
          handleValue({
            name: name, value: newValue ? (cityOnly ? {
              ...newValue,
              structured_formatting: {
                ...newValue.structured_formatting,
                main_text: (newValue.structured_formatting.main_text).replace('Add ', '')
              }
            } :
              {
                ...newValue,
                description: (newValue.description).replace('Add ', ''),
                structured_formatting: {
                  ...newValue.structured_formatting,
                  main_text: (newValue.structured_formatting.main_text).replace('Add ', '')
                }
              }) : null
          })
        }
      }}
      onInputChange={e => {
        e && fetchPlaces(e.target.value)
      }}
      selectOnFocus
      clearOnBlur
      handleHomeEndKeys
      options={placeDetails}
      getOptionLabel={option => {
        return option.description ? (cityOnly ? option.structured_formatting.main_text : option.description) : option;;
      }}
      renderOption={(props, { structured_formatting, place_id }) => {
        return (
          <>
            <ListItemText key={place_id} {...props} style={{ border: 'none', borderRadius: '5px' }}>
              <Typography style={{ fontFamily: 'poppins', fontSize: '14px', color: '#66668f' }}>
                {structured_formatting?.main_text}
              </Typography>
              <Typography style={{ fontFamily: 'poppins', fontSize: '14px', color: '#66668f' }}>
                {structured_formatting?.secondary_text}
              </Typography>
            </ListItemText>
          </>
        )
      }}
      renderInput={params => (
        <TextField
          required={required}
          bgwhite={bgwhite}
          borderLess={borderLess}
          {...params}
          label={label}
          InputLabelProps={{ shrink: false }}
        />
      )}
      filterOptions={(options, params) => {
        const filtered = filter(options, params)
        const { inputValue } = params
        // Suggest the creation of a new value
        const isExisting = options.some(option => inputValue === option)
        if (inputValue !== '' && !isExisting) {
          filtered.push(cityOnly ? {
            structured_formatting:
            {
              main_text: `Add ${inputValue}`
            }
          } : {
            description: `Add ${inputValue}`,
            structured_formatting:
            {
              main_text: `Add ${inputValue}`
            }
          })
        }
        return filtered
      }}
      noOptionsText={
        <Typography variant="h6" style={{ fontFamily: 'poppins', fontWeight: 'bold', fontSize: '12px' }}>
          Please select address from the drop-down menu options
        </Typography>
      }
      componentsProps={{
        popper: {
          className: `CustomAutoComplete ${zIndex ? 'showTopStack' : 'showDefaultStack'}`,
        },
      }}
    />
  )
}

export default PlaceAutoComplete
